<template>
<div id="app" v-bind:class="{ 'noauth': !isLoggedIn }">
  <header-bar class="header"></header-bar>
  <div class="page">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <footer />
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '@/components/headerBar/headerBar'
export default {
  name: 'app',
  components: {
    HeaderBar
  },
  computed: {
    ...mapGetters([
      'isLoggedIn'
    ])
  }
}
</script>

<style lang="scss" src="./stylesheets/main.scss"></style>



// WEBPACK FOOTER //
// App.vue?4b27329e